import { useEffect } from 'react'

export enum KeyTypeEnum {
  Back = 'back',
  Stop = 'stop',
  FastForward = 'fastForward',
  Rewind = 'rewind',
  Pause = 'pause',
  Left = 'left',
  Right = 'right',
  Up = 'up',
  Down = 'down',
  Enter = 'enter',
  PlayPause = 'playPause',
  Play = 'play',
}

const KEY_MAP = {
  back: {
    keys: ['Backspace', 'Back'],
    codes: [8, 166, 10009],
  },
  stop: {
    keys: ['Stop'],
    codes: [413],
  },
  fastForward: {
    keys: ['FFW'],
    codes: [417, 228],
  },
  rewind: {
    keys: ['RW'],
    codes: [412, 227],
  },
  pause: {
    keys: ['Pause'],
    codes: [19, 179],
  },
  left: {
    keys: ['ArrowLeft', 'Left'],
    codes: [37],
  },
  up: {
    keys: ['ArrowUp', 'Up'],
    codes: [38],
  },
  right: {
    keys: ['ArrowRight', 'Right'],
    codes: [39],
  },
  down: {
    keys: ['ArrowDown', 'Down'],
    codes: [40],
  },
  enter: {
    keys: ['Enter'],
    codes: [13],
  },
  playPause: {
    keys: [''],
    codes: [10252, 179],
  },
  play: {
    keys: ['Play'],
    codes: [415],
  },
}
/**
 * @deprecated use `useKeyDown` from `shared/providers/KeyDownProvider/KeyDownProvider.tsx` instead.
 */
export const useKeyDownHandler = (
  types: KeyTypeEnum[],
  handler: (typeKey: KeyTypeEnum) => void,
  stopPropagation = true
) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      for (const type of types) {
        const { keys, codes } = KEY_MAP[type]
        // Although keyCode is deprecated, some devices don't support key
        if (keys.includes(e.key) || codes.includes(e.keyCode)) {
          stopPropagation && e.stopPropagation()
          handler(type)
          break
        }
      }
    }
    window.addEventListener('keydown', handleKey, { capture: true })
    return () => {
      window.removeEventListener('keydown', handleKey, { capture: true })
    }
  }, [types, handler])
}
